import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'admin-travel-info-form',
  templateUrl: './travel-info-form.component.html',
  styleUrls: ['./travel-info-form.component.css','../admin.css']
})
export class AdminTravelInfoFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  triggerClick(id){
   (<HTMLInputElement>window.document.getElementById(id)).click()
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/travel-info-form/travel-info-form.component.ts